import axios from 'axios'

import { type NewsArticle } from './newsArticle.type'

export const NewsArticleService = {
  baseUrl: '/api/newsArticles',

  async getAll(): Promise<NewsArticle[]> {
    const { data } = await axios.get<NewsArticle[]>(this.baseUrl)
    return data
  },

  async setVisible(id: string, value: boolean): Promise<NewsArticle> {
    const { data } = await axios.put<NewsArticle>(
      `${this.baseUrl}/${id}/visible`,
      null,
      { params: { value } },
    )
    return data
  },

  async delete(id: string): Promise<void> {
    await axios.delete(`${this.baseUrl}/${id}`)
  },
}
